import { render, staticRenderFns } from "./verTurno.vue?vue&type=template&id=56320300&scoped=true&"
import script from "./verTurno.vue?vue&type=script&lang=js&"
export * from "./verTurno.vue?vue&type=script&lang=js&"
import style0 from "./verTurno.vue?vue&type=style&index=0&id=56320300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56320300",
  null
  
)

export default component.exports